// Thin wrapper over navigator.vibrate with safe fallbacks. On iOS Safari
// the API is unavailable; on desktop it's typically a no-op. We swallow
// any error so a missing API never breaks the game loop.

interface VibrateNavigator {
  vibrate?: (p: number | number[]) => boolean;
}

export function vibrate(pattern: number | number[]): void {
  if (typeof navigator === 'undefined') return;
  const nav = navigator as Navigator & VibrateNavigator;
  if (typeof nav.vibrate !== 'function') return;
  try {
    nav.vibrate(pattern);
  } catch {
    // ignore — some browsers throw on unexpected patterns
  }
}

// Curated pulse signatures for common gameplay events.
export const HAPTIC = {
  detect: 50,
  ko: [0, 30, 20, 30] as number[],
  capture: [0, 200, 50, 200] as number[],
  win: [0, 50, 30, 50, 30, 100] as number[],
};
